export default {
  Lost: {
    Warning: {
      WariningOnlyTickLostForReportLostAsset: "Chỉ được đánh dấu mất tài sản báo mất",
      WariningOnlyTickLostForReportLostAssetContinue:
        "Chỉ được đánh dấu mất tài sản báo mất, bạn có muốn tiếp tục không?",
    },
  },
  Liquidation: {
    Warning: {
      WariningOnlyTickLiquidationForReportLiquidationAsset:
        "Chỉ được thanh lý tài sản Đề nghị thanh lý",
      WariningOnlyTickLiquidationForReportLiquidationAssetInAssetList:
        "Chỉ được thanh lý tài sản có trạng thái khác: Đã hủy; Đã mất; Thanh lý",
      WariningOnlyTickLiquidationForReportLiquidationAssetContinue:
        "Chỉ được thanh lý tài sản Đề nghị thanh lý, bạn có muốn tiếp tục không?",
      WariningOnlyTickLiquidationForReportLiquidationAssetContinueInAssetList:
        "Chỉ được thanh lý tài sản có trạng thái khác: Đã hủy; Đã mất; Thanh lý, bạn có muốn tiếp tục không?",
    },
  },
  RequestLiquidation: {
    Warning: {
      WariningOnlyTickLiquidationForReportLiquidationAsset:
        "Chỉ được thanh lý tài sản Đề nghị thanh lý",
      WariningOnlyTickRequestLiquidationForRequestLiquidationAssetInAssetList:
        "Chỉ được Đề nghị thanh lý tài sản có trạng thái khác: Đã hủy; Đã mất; Đã thanh lý, Đề nghị thanh lý",
      WariningOnlyTickLiquidationForReportLiquidationAssetContinue:
        "Chỉ được thanh lý tài sản Đề nghị thanh lý, bạn có muốn tiếp tục không?",
      WariningOnlyTickRequestLiquidationForRequestLiquidationAssetContinueInAssetList:
        "Chỉ được thanh lý tài sản có trạng thái khác: Đã hủy; Đã mất; Đã thanh lý, Đề nghị thanh lý, bạn có muốn tiếp tục không?",
    },
  },
};
